import { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button'

import Icon from '@/components/Icon/Icon'
import { scrollToTop } from '@/utils/helpers'

import styles from './ScrollToTopButton.module.scss'

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false)

  const toggleVisible = () => {
    if (window.innerWidth >= 768 && document.documentElement.scrollTop > 1000) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible)
  }, [])

  return (
    <div className={styles.container} style={{ display: visible ? 'inline' : 'none' }}>
      <Button onClick={scrollToTop}>
        <Icon icon='arrowUp' /> Top
      </Button>
    </div>
  )
}

export default ScrollToTopButton
